import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Platform_iOS_instance;
var Platform_Android_instance;
var Platform_Web_instance;
var Platform_Desktop_instance;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var Platform_entriesInitialized;
function Platform_initEntries() {
  if (Platform_entriesInitialized)
    return Unit_instance;
  Platform_entriesInitialized = true;
  Platform_iOS_instance = Platform().bcv('iOS', 0);
  Platform_Android_instance = Platform().bcv('Android', 1);
  Platform_Web_instance = Platform().bcv('Web', 2);
  Platform_Desktop_instance = Platform().bcv('Desktop', 3);
}
var PlatformClass;
function Platform() {
  if (PlatformClass === VOID) {
    class $ extends Enum() {
      static bcv(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'Platform');
    PlatformClass = $;
  }
  return PlatformClass;
}
function Platform_Web_getInstance() {
  Platform_initEntries();
  return Platform_Web_instance;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Platform_Web_getInstance as Platform_Web_getInstanceu4ctcncq1n0,
  Companion_instance as Companion_instance2rgq1hlpwff0j,
};
//endregion

//# sourceMappingURL=Platform.mjs.map
